import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accidentaldamage" }
const _hoisted_2 = {
  class: "container aos-init aos-animate",
  "data-aos": "fade",
  "data-aos-duration": "2000"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "poweredby",
  style: {"font-size":"14px","padding":"8px !important","margin-bottom":"10px"}
}, "  Optional Add-on  ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Accidental Damage Personal Property Coverage", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Coverage if you crack your phone screen or spill coffee on your laptop. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)

import BaseModal from "@/views/modals/BaseModal.vue";
import useModal from "@/hooks/useModal";
import Modals from "@/utils/Modals";
import AccidentalDamageModal from "@/views/modals/context/AccidentalDamageModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccidentalDamage',
  setup(__props) {

const modalLabel = Modals.ACCIDENTAL_DAMAGE_MODAL.label;
const { toggleModal } = useModal();
const showAccidentalDamageModal = () => {
  toggleModal(Modals.ACCIDENTAL_DAMAGE_MODAL.label + "2");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showAccidentalDamageModal()))
        }, "Learn More")
      ]),
      _hoisted_8
    ]),
    _createVNode(BaseModal, {
      name: _unref(modalLabel) + '2'
    }, {
      default: _withCtx(() => [
        _createVNode(AccidentalDamageModal)
      ]),
      _: 1
    }, 8, ["name"])
  ], 64))
}
}

})